export function useSubmitReviewForm() {
  return useFormHandler<{ message: string }>({
    schema: submitReviewSchema,
    action: "submit_review",
  });
}
